'use client';
import React from 'react';
import { usePermission } from './usePermission';
import { getValueFromCookie } from '@benzinga/utils';

export const useIsUserEditor = (): boolean => {
  const isEditor = usePermission('editorial/edit');
  const [hasAccess, setHasAccess] = React.useState(isEditor);
  React.useEffect(() => {
    if (getValueFromCookie('bz_edit')) {
      setHasAccess(true);
    } else if (typeof window !== 'undefined') {
      if (isEditor) {
        window.localStorage.setItem('editorial/edit', '1');
      }
      const authorized = window.localStorage && window.localStorage.getItem('editorial/edit') ? true : false;
      setHasAccess(authorized);
    }
  }, [isEditor]);
  return hasAccess;
};
